import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=21795a5c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=21795a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21795a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21795a5c')) {
      api.createRecord('21795a5c', component.options)
    } else {
      api.reload('21795a5c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=21795a5c&scoped=true&", function () {
      api.rerender('21795a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t2IY3FDbFOJC/JS/comp/PopupDialog.vue"
export default component.exports